export default __webpack_public_path__ + "static/logo-ff3be6e25dab9c742cd6d11d87208b78.png";